<template>
  <va-modal
    id="incrementRequestEstimatedDuration"
    ref="incrementRequestEstimatedDuration"
    :value="isOpen"
    :okText="$t('modals.buttons.save')"
    :okDisabled="isSubmitingForm"
    :cancelText="$t('modals.buttons.back')"
    @ok="submitForm"
    @cancel="onCancel"
  >

  <div slot="header" class="modal-title pb-3">
      <span>{{ $t('evocall.requests.increment_request_estimated_duration_title', {name: request.name})}}</span>
  </div>

  <div class="row">
    <p class="col-12">{{$t('evocall.requests.estimated_duration')}}: <span class="is-bold">{{`${request.estimatedDuration} ${$t('time.minutes')}`}}</span></p>
    <p class="col-12">{{$t('evocall.requests.accepted_at')}}: <span class="is-bold">{{request.startedAt | localTime('YYYY-MM-DD HH:mm')}}</span></p>
    <p class="col-12">{{$t('evocall.requests.estimated_end_time')}}: <span class="is-bold">{{estimatedEndTime | localTime('YYYY-MM-DD HH:mm')}}</span></p>
  </div>

  <form class="evollu-form">
    <div class="row mb-0">
      <div class="col-12">
        <label class="form-label">
          {{ $t('evocall.requests.estimated_duration') }}:
        </label>
        <multiselect
          id="appointment-status"
          v-model="form.data.estimated_duration_increment"
          :options="durationIncrementOptions"

          :customLabel="option => $t(option.name)"
          track-by="id"
          :allow-empty="false"
          :multiple="false"
          open-direction="bottom"
          >
        </multiselect>
      </div>
    </div>

  </form>

  </va-modal>
</template>

<script>
import { RequestService } from '@/api/VirtualWaitingRoomService'
import Multiselect from 'vue-multiselect'

export default {
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  components: {
    Multiselect
  },
  computed: {
    estimatedEndTime: function () {
      if (this.request && this.request.accepted_at !== null && this.form.data.estimated_duration_increment) {
        return this.moment(this.request.accepted_at).add(this.form.data.estimated_duration_increment.value, 'minutes')
      }
      return null
    }
  },
  data: function () {
    return {
      isOpen: false,
      durationIncrementOptions: [
        { id: 1, value: 10, name: 'evocall.requests.estimated_duration_increments.1' },
        { id: 2, value: 15, name: 'evocall.requests.estimated_duration_increments.2' },
        { id: 3, value: 20, name: 'evocall.requests.estimated_duration_increments.3' },
        { id: 4, value: 25, name: 'evocall.requests.estimated_duration_increments.4' },
        { id: 5, value: 30, name: 'evocall.requests.estimated_duration_increments.5' },
        { id: 6, value: 35, name: 'evocall.requests.estimated_duration_increments.6' },
        { id: 7, value: 40, name: 'evocall.requests.estimated_duration_increments.7' },
        { id: 8, value: 45, name: 'evocall.requests.estimated_duration_increments.8' },
        { id: 9, value: 50, name: 'evocall.requests.estimated_duration_increments.9' },
        { id: 10, value: 55, name: 'evocall.requests.estimated_duration_increments.10' },
        { id: 11, value: 60, name: 'evocall.requests.estimated_duration_increments.11' },
        { id: 12, value: 75, name: 'evocall.requests.estimated_duration_increments.12' },
        { id: 13, value: 90, name: 'evocall.requests.estimated_duration_increments.13' },
        { id: 14, value: 105, name: 'evocall.requests.estimated_duration_increments.14' }
      ],
      form: {
        data: {
          estimated_duration_increment: null
        }
      },
      isSubmitingForm: false,
    }
  },
  mounted: function () {
    this.isOpen = true
    this.form.data.estimated_duration_increment = this.durationIncrementOptions.find(duration => duration.value === this.request.estimated_duration) || this.durationIncrementOptions[4]
  },
  methods: {
    getFormData: function () {
      if (this.form.data.estimated_duration_increment !== null) {
        return {
          estimated_duration: this.form.data.estimated_duration_increment.value
        }
      }
    },
    submitForm: function () {
      if (!this.isSubmitingForm) {
        this.isSubmitingForm = true
        RequestService.updateDuration(this.request.id, this.getFormData())
          .then(request => {
            this.$emit('request-updated', request)
            this.onCancel()
          })
          .catch(errors => {
            console.log(errors)
            this.showToast(this.$t('evocall.requests.update_estimated_duration_failed'))
          })
          .finally(() => {
            this.isSubmitingForm = false
          })
      }
    },
    onCancel: function () {
      this.isOpen = false
      setTimeout(() => {
        this.$emit('cancel')
      }, 500)
    }
  }
}
</script>

<style lang="scss">

#incrementRequestEstimatedDuration {
  .multiselect__content-wrapper {
    position: relative !important;
  }
}

</style>
